import React, { useEffect, useState } from 'react'
import { IAdminPage } from '../../Interfaces'
import GenerateIcon from '../../../../components/GenerateIcon'
import { Link, useParams } from 'react-router-dom'
import { AdminPagesService } from '../../adminPagesSlice'
import BetaLabel from '../BetaLabel'
import { useReturnCurrentUser } from '../../../user/userSlice'

interface IProps extends IAdminPage {

}

function SubSidebarItem(props: IAdminPage){

    const { name, title, icon, isBeta } = props


    const params = useParams()

    return(
        <Link to={`/panel/${name}`}>
            <div className={params.page_name == name ? "single-sub-admin-sidebar-item-box active" : "single-sub-admin-sidebar-item-box"}>
                <div className="content-of-single-sub-admin-sidebar-item-box">
                    <h3>{title}</h3>
                </div>
            </div>
        </Link>
    )
}

export default function AdminSidebarItem(props: IProps) {

    const { name, title, icon, subPages, subPageName, isBeta } = props

    const params = useParams()
    const currentPage = AdminPagesService.usePageDetails(params.page_name ? params.page_name : "")

    const currentUser = useReturnCurrentUser()

    const baseContainerClassName: string = "single-admin-sidebar-item-container"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    useEffect(() => {

        if (currentPage.name === name){
            setContainerClassName(`${baseContainerClassName} active`)
        }else{
            setContainerClassName(baseContainerClassName)
        }

        if (currentPage.subPageName){
            if (currentPage.subPageName === name){
                setContainerClassName(`${baseContainerClassName} active`)
            }else{
                setContainerClassName(baseContainerClassName)
            }
        }


    }, [currentPage])
    
    return(
        <div className={containerClassName}>
            <div className="content-of-single-admin-sidebar-item-container">


                <Link to={`/panel/${name}`}>
                    <div className="single-admin-sidebar-item-box">
                        <div className="content-of-single-admin-sidebar-item-box">

                            <div className="icon-of-single-admin-sidebar-item-box">
                                <div className="content-of-icon-of-sinlge-admin-sidebar-item-box">
                                    <GenerateIcon icon={icon} />
                                </div>  
                            </div>

                            <div className="text-of-sinlge-admin-sidebar-item-box">
                                <div className="content-of-text-of-sinlge-admin-sidebar-item-box">
                                    <h3>
                                        {title}

                                        {isBeta && <BetaLabel />}
                                    </h3>
                                </div>
                            </div>

                            <div className="open-icon-of-sinlge-admin-sidebar-item-box">
                                <div className="content-of-open-icon-of-sinlge-admin-sidebar-item-box">

                                </div>
                            </div>

                        </div>
                    </div>
                </Link>

                {/* Sub items */}

                {subPages.length > 0 && (
                    <div className="subitems-of-single-admin-sidebar-item-box">
                        <div className="content-of-subitems-of-sinlge-admin-sidebar-item-box">
                            {subPages.map((subPage: IAdminPage, index: number) => <SubSidebarItem {...subPage} key={index} />)}
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}